"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stanEvalSchema = exports.userReadStanEvalSchema = void 0;
const yup = __importStar(require("yup"));
exports.userReadStanEvalSchema = yup.object().shape({
    userId: yup.string().required(),
    readAt: yup.string().matches(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/, 'Must be ISO date string').required(),
});
exports.stanEvalSchema = yup.object().shape({
    id: yup.string().notRequired(),
    displayName: yup.string().required(),
    userId: yup.string().required(),
    squadronId: yup.string().required(),
    userName: yup.string().required(),
    userLastName: yup.string().required(),
    fileName: yup.string().required(),
    createdAt: yup.string().matches(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/, 'Must be ISO date string').required(),
    expiresAt: yup.string().matches(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/, 'Must be ISO date string').notRequired(),
    readUsers: yup.array().of(exports.userReadStanEvalSchema).required().default([]),
});
